// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css - 登录页面样式 */

/* Overlay背景 */
.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(5, 8, 16, 0.85);
  backdrop-filter: blur(15px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Modal容器 */
.login-modal {
  position: relative;
  width: 90%;
  max-width: 420px;
  background: linear-gradient(145deg, rgba(16, 22, 42, 0.95), rgba(10, 15, 28, 0.98));
  border: 1px solid rgba(0, 229, 255, 0.3);
  border-radius: 24px;
  padding: 40px 35px;
  box-shadow:
    0 25px 70px rgba(0, 0, 0, 0.7),
    0 0 40px rgba(0, 229, 255, 0.15),
    inset 0 0 30px rgba(0, 229, 255, 0.05);
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 关闭按钮 */
.login-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: var(--text-dim);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.login-close-btn:hover {
  background: rgba(255, 59, 48, 0.2);
  border-color: rgba(255, 59, 48, 0.4);
  color: #ff3b30;
  transform: rotate(90deg);
}

/* 返回按钮 */
.back-btn {
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(0, 229, 255, 0.1);
  border: 1px solid rgba(0, 229, 255, 0.2);
  color: var(--primary);
  padding: 8px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(0, 229, 255, 0.2);
  border-color: rgba(0, 229, 255, 0.4);
  transform: translateX(-3px);
}

/* 登录内容区 */
.login-content {
  margin-top: 10px;
}

/* 标题区域 */
.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.6rem;
  font-weight: 700;
  background: linear-gradient(
    to right,
    #ffffff 0%,
    #00e5ff 50%,
    #7e57ff 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  margin-bottom: 8px;
}

.login-header p {
  color: var(--text-dim);
  font-size: 0.9rem;
}

/* 登录选项按钮 */
.login-options {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.google-btn,
.email-btn {
  width: 100%;
  padding: 14px 20px;
  border-radius: 14px;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  font-family: 'Exo 2', sans-serif;
}

.google-btn {
  background: #fff;
  border: 1px solid #e0e0e0;
  color: #333;
}

.google-btn:hover {
  background: #f8f8f8;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.email-btn {
  background: rgba(0, 229, 255, 0.1);
  border: 1px solid rgba(0, 229, 255, 0.3);
  color: var(--primary);
}

.email-btn:hover {
  background: rgba(0, 229, 255, 0.2);
  border-color: rgba(0, 229, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 229, 255, 0.25);
}

/* 表单样式 */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 0.85rem;
  color: var(--text-dim);
  font-weight: 500;
  margin-left: 4px;
}

.form-group input {
  padding: 14px 16px;
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 0.95rem;
  font-family: 'Exo 2', sans-serif;
  transition: all 0.3s ease;
  outline: none;
}

.form-group input:focus {
  background: rgba(0, 0, 0, 0.6);
  border-color: var(--primary);
  box-shadow:
    0 0 15px rgba(0, 229, 255, 0.15),
    inset 0 0 10px rgba(0, 229, 255, 0.05);
}

.form-group input::placeholder {
  color: rgba(160, 174, 192, 0.5);
}

/* 错误提示 */
.login-error {
  padding: 12px 16px;
  background: rgba(255, 59, 48, 0.15);
  border: 1px solid rgba(255, 59, 48, 0.3);
  border-radius: 10px;
  color: #ff6b6b;
  font-size: 0.85rem;
  text-align: center;
}

/* 成功提示 */
.login-success {
  padding: 12px 16px;
  background: rgba(52, 199, 89, 0.15);
  border: 1px solid rgba(52, 199, 89, 0.3);
  border-radius: 10px;
  color: #34c759;
  font-size: 0.85rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #0072ff, #00e5ff);
  border: none;
  border-radius: 14px;
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  font-family: 'Orbitron', sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.4s ease;
  margin-top: 8px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 10px 25px rgba(0, 229, 255, 0.4),
    0 0 30px rgba(0, 229, 255, 0.2);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Footer区域 */
.login-footer {
  margin-top: 25px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.login-footer p {
  color: var(--text-dim);
  font-size: 0.85rem;
}

.link-btn {
  background: none;
  border: none;
  color: var(--primary);
  font-size: 0.85rem;
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.3s ease;
}

.link-btn:hover {
  color: #7e57ff;
  text-decoration: underline;
}

/* Header中的按钮样式 */
.header-actions {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  gap: 12px;
  align-items: center;
}

.login-btn,
.user-profile-btn {
  background: rgba(0, 229, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 229, 255, 0.3);
  color: #00d9ff;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  font-family: 'Orbitron', sans-serif;
  font-weight: 500;
  letter-spacing: 1px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 0 15px rgba(0, 217, 255, 0.2);
}

.login-btn:hover,
.user-profile-btn:hover {
  background: rgba(0, 229, 255, 0.2);
  border-color: rgba(0, 229, 255, 0.5);
  box-shadow: 0 0 20px rgba(0, 217, 255, 0.4);
  transform: translateY(-2px);
}

.login-btn i,
.user-profile-btn i {
  font-size: 0.9rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-modal {
    width: 95%;
    padding: 30px 25px;
  }

  .header-actions {
    right: 15px;
    gap: 8px;
  }

  .login-btn,
  .user-profile-btn {
    padding: 6px 12px;
    font-size: 0.75rem;
    gap: 6px;
  }

  .login-btn span,
  .user-profile-btn span {
    display: none;
  }

  .login-btn i,
  .user-profile-btn i {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .login-modal {
    padding: 25px 20px;
  }

  .login-header h2 {
    font-size: 1.3rem;
  }

  .google-btn,
  .email-btn {
    padding: 12px 16px;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mFAAmF;EACnF,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB;;;0CAGwC;EACxC,qDAAqD;AACvD;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;EACd,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB;;;;;GAKC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B;;0CAEwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B;;mCAEiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,2BAA2B;EAC3B,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;EACpC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":["/* Login.css - 登录页面样式 */\n\n/* Overlay背景 */\n.login-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(5, 8, 16, 0.85);\n  backdrop-filter: blur(15px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Modal容器 */\n.login-modal {\n  position: relative;\n  width: 90%;\n  max-width: 420px;\n  background: linear-gradient(145deg, rgba(16, 22, 42, 0.95), rgba(10, 15, 28, 0.98));\n  border: 1px solid rgba(0, 229, 255, 0.3);\n  border-radius: 24px;\n  padding: 40px 35px;\n  box-shadow:\n    0 25px 70px rgba(0, 0, 0, 0.7),\n    0 0 40px rgba(0, 229, 255, 0.15),\n    inset 0 0 30px rgba(0, 229, 255, 0.05);\n  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* 关闭按钮 */\n.login-close-btn {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  width: 36px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  color: var(--text-dim);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.login-close-btn:hover {\n  background: rgba(255, 59, 48, 0.2);\n  border-color: rgba(255, 59, 48, 0.4);\n  color: #ff3b30;\n  transform: rotate(90deg);\n}\n\n/* 返回按钮 */\n.back-btn {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  background: rgba(0, 229, 255, 0.1);\n  border: 1px solid rgba(0, 229, 255, 0.2);\n  color: var(--primary);\n  padding: 8px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.3s ease;\n}\n\n.back-btn:hover {\n  background: rgba(0, 229, 255, 0.2);\n  border-color: rgba(0, 229, 255, 0.4);\n  transform: translateX(-3px);\n}\n\n/* 登录内容区 */\n.login-content {\n  margin-top: 10px;\n}\n\n/* 标题区域 */\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h2 {\n  font-family: 'Orbitron', sans-serif;\n  font-size: 1.6rem;\n  font-weight: 700;\n  background: linear-gradient(\n    to right,\n    #ffffff 0%,\n    #00e5ff 50%,\n    #7e57ff 100%\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  margin-bottom: 8px;\n}\n\n.login-header p {\n  color: var(--text-dim);\n  font-size: 0.9rem;\n}\n\n/* 登录选项按钮 */\n.login-options {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.google-btn,\n.email-btn {\n  width: 100%;\n  padding: 14px 20px;\n  border-radius: 14px;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  transition: all 0.3s ease;\n  font-family: 'Exo 2', sans-serif;\n}\n\n.google-btn {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  color: #333;\n}\n\n.google-btn:hover {\n  background: #f8f8f8;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.email-btn {\n  background: rgba(0, 229, 255, 0.1);\n  border: 1px solid rgba(0, 229, 255, 0.3);\n  color: var(--primary);\n}\n\n.email-btn:hover {\n  background: rgba(0, 229, 255, 0.2);\n  border-color: rgba(0, 229, 255, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(0, 229, 255, 0.25);\n}\n\n/* 表单样式 */\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 0.85rem;\n  color: var(--text-dim);\n  font-weight: 500;\n  margin-left: 4px;\n}\n\n.form-group input {\n  padding: 14px 16px;\n  background: rgba(0, 0, 0, 0.4);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  color: #fff;\n  font-size: 0.95rem;\n  font-family: 'Exo 2', sans-serif;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.form-group input:focus {\n  background: rgba(0, 0, 0, 0.6);\n  border-color: var(--primary);\n  box-shadow:\n    0 0 15px rgba(0, 229, 255, 0.15),\n    inset 0 0 10px rgba(0, 229, 255, 0.05);\n}\n\n.form-group input::placeholder {\n  color: rgba(160, 174, 192, 0.5);\n}\n\n/* 错误提示 */\n.login-error {\n  padding: 12px 16px;\n  background: rgba(255, 59, 48, 0.15);\n  border: 1px solid rgba(255, 59, 48, 0.3);\n  border-radius: 10px;\n  color: #ff6b6b;\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n/* 成功提示 */\n.login-success {\n  padding: 12px 16px;\n  background: rgba(52, 199, 89, 0.15);\n  border: 1px solid rgba(52, 199, 89, 0.3);\n  border-radius: 10px;\n  color: #34c759;\n  font-size: 0.85rem;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* 提交按钮 */\n.submit-btn {\n  width: 100%;\n  padding: 15px;\n  background: linear-gradient(135deg, #0072ff, #00e5ff);\n  border: none;\n  border-radius: 14px;\n  color: #fff;\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: 'Orbitron', sans-serif;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: all 0.4s ease;\n  margin-top: 8px;\n}\n\n.submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow:\n    0 10px 25px rgba(0, 229, 255, 0.4),\n    0 0 30px rgba(0, 229, 255, 0.2);\n}\n\n.submit-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Footer区域 */\n.login-footer {\n  margin-top: 25px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.login-footer p {\n  color: var(--text-dim);\n  font-size: 0.85rem;\n}\n\n.link-btn {\n  background: none;\n  border: none;\n  color: var(--primary);\n  font-size: 0.85rem;\n  cursor: pointer;\n  padding: 4px 8px;\n  transition: all 0.3s ease;\n}\n\n.link-btn:hover {\n  color: #7e57ff;\n  text-decoration: underline;\n}\n\n/* Header中的按钮样式 */\n.header-actions {\n  position: absolute;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.login-btn,\n.user-profile-btn {\n  background: rgba(0, 229, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(0, 229, 255, 0.3);\n  color: #00d9ff;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  font-family: 'Orbitron', sans-serif;\n  font-weight: 500;\n  letter-spacing: 1px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 0 15px rgba(0, 217, 255, 0.2);\n}\n\n.login-btn:hover,\n.user-profile-btn:hover {\n  background: rgba(0, 229, 255, 0.2);\n  border-color: rgba(0, 229, 255, 0.5);\n  box-shadow: 0 0 20px rgba(0, 217, 255, 0.4);\n  transform: translateY(-2px);\n}\n\n.login-btn i,\n.user-profile-btn i {\n  font-size: 0.9rem;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .login-modal {\n    width: 95%;\n    padding: 30px 25px;\n  }\n\n  .header-actions {\n    right: 15px;\n    gap: 8px;\n  }\n\n  .login-btn,\n  .user-profile-btn {\n    padding: 6px 12px;\n    font-size: 0.75rem;\n    gap: 6px;\n  }\n\n  .login-btn span,\n  .user-profile-btn span {\n    display: none;\n  }\n\n  .login-btn i,\n  .user-profile-btn i {\n    font-size: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-modal {\n    padding: 25px 20px;\n  }\n\n  .login-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .google-btn,\n  .email-btn {\n    padding: 12px 16px;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
